const education = [
  {
    degree: "Bachelor of Science in Information Technology",
    institution: "Fontys University of Applied Sciences, Venlo",
    duration: "2024 - Current",
    description: "A comprehensive program covering software development, data science, security, and business IT. Students gain hands-on experience through projects, internships, and a final-year capstone.",
    courses: [
      "Software Engineering & Development",
      "Algorithms & Data Structures",
      "Concurrent Programming",
      "Cybersecurity & Ethical Hacking",
      "Business IT & Management Systems",
      "Embedded Systems & IoT",
      "Machine Learning & AI"
    ],
    achievements: [
      "Completed a special program that allows me to follow an accelerated version of this Bachelor's degree, skipping certain parts",
    ]
  },
  {
    degree: "Software Developer",
    institution: "Gilde ICT College, Roermond",
    duration: "2021 - 2025",
    description: "Gained hands-on experience by working on real-world client-based projects, focusing on PHP, Python, and software development best practices.",
    courses: [
      "Full-Stack Web Development (PHP, Python, HTML/CSS)",
      "Object-Oriented Programming (Python)",
      "Database Management (MySQL, PostgreSQL)",
      "Project-Based Software Development",
      "Software Architecture & Design Patterns"
    ],
    achievements: [
      "Developed a POS system for a restaurant using PHP",
      "Created a Audiometer tool to determin the hearing of special needs childeren",
      "Completed an internship at IBI², working on sustainability tools",
      "Successfully passed a rigorous final exam project for a driving school management system",
      "Completed an internship at AppComm, creating a inhouse hour registration system and file convertion system to connect different systems."
    ]
  },
];

export default education;